import 'lib/ApmRum';
import './polyfills';
import * as React from 'react';
import ReactDOM from 'react-dom/client';
import {Provider} from 'react-redux';
import ReduxStore, {persistor, storeUsesPersist} from './ReduxStore';
import axiosErrorHandlerInitialise from './api/AxiosSupport';
import RoutesContainer from './RoutesContainer';
import {PersistGate} from 'redux-persist/integration/react';
import reportWebVitals from './reportWebVitals';
import BugsnagClient from './bugsnag';
import './index.css';
import { ThemeProvider, StyledEngineProvider } from '@mui/material';
import MaterialUI from './setup/MaterialUI';

// Unregister any existing service workers and clear all caches
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => registration.unregister());
    });
    caches.keys().then((cacheNames) => {
        cacheNames.forEach((cacheName) => caches.delete(cacheName));
    });
}

const ErrorBoundary = BugsnagClient.getPlugin('react').createErrorBoundary(React);
axiosErrorHandlerInitialise();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ErrorBoundary>
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={MaterialUI.appTheme}>
                <Provider store={ReduxStore}>
                    {storeUsesPersist ? (
                        <PersistGate loading={null} persistor={persistor}>
                            <RoutesContainer/>
                        </PersistGate>
                    ) : (
                        <RoutesContainer/>
                    )}
                </Provider>
            </ThemeProvider>
        </StyledEngineProvider>
    </ErrorBoundary>
);
reportWebVitals();